/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';
import {CustomEventResource} from '../../../components/api/resources/resource/custom-event.resource';

@Component({
  standalone: false,
  selector: 'adn-custom-event-route-page',
  template: `
    <adn-custom-event-list-page
      *ngIf="list"
      [list]="list">
    </adn-custom-event-list-page>
  `
})
export class CustomEventRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(CustomEventResource) private readonly CustomEvent: any
  ) {
  }

  ngOnInit(): void {
    this.adnListHelper.setUpList(this.list, this.CustomEvent, false, 'fullCustomEventList', {
      baseTable: 'customEvent'
    });
  }
}
